import * as yup from "yup";

// 로그인 폼 데이터 타입
export interface LoginFormData {
  userId: string;
  password: string;
  isIdSave: boolean;
}
// 로그인 폼 유효성 검사 스키마
export const loginSchema = yup.object({
  userId: yup
    .string()
    .required("logIn.enterUserEmail")
    .email("logIn.signUp.invalidEmailFormat"),
  password: yup
    .string()
    .required("logIn.enterPassword")
    .min(1, "logIn.enterPassword"),
  isIdSave: yup.boolean().default(false),
});
